export const NAME = 'disenrollment';

export const REQUEST_DISENROLLMENT = 'REQUEST_DISENROLLMENT';
export const SUCCESS_DISENROLLMENT = 'SUCCESS_DISENROLLMENT';
export const FAILURE_DISENROLLMENT = 'FAILURE_DISENROLLMENT';



// WEBPACK FOOTER //
// ./src/services/disenrollment/constants.js